let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kcnVo")).then(() => parcelRequire('1g59F'));